import api from './Api';

export const applyOutletMenuActions = async (actions) => {
   return api.post(
      `${process.env.REACT_APP_BASE_URL}menu/admin/actions/`,
      actions
   ).then(response => response.data);
};
